import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { createCheckout } from "../lib/api";

type Cohort = { id: string; name: string; seat_cap: number; session1_at: string | null };

export default function Home() {
  const [cohorts, setCohorts] = useState<Cohort[]>([]);
  const [status, setStatus] = useState<string>("loading…");
  const [email, setEmail] = useState<string>("");
  const [busyId, setBusyId] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    supabase
      .from("cohorts")
      .select("id,name,seat_cap,session1_at")
      .then(({ data, error }) => {
        if (error) setStatus(error.message);
        else {
          setCohorts(data ?? []);
          setStatus(data && data.length ? "" : "No cohorts open right now.");
        }
      });
  }, []);

  async function enroll(cohortId: string) {
    setError("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setError("Enter a valid email to reserve your seat.");
      return;
    }
    setBusyId(cohortId);
    try {
      const { url } = await createCheckout(cohortId, email.trim());
      window.location.href = url; // redirect to Stripe Checkout
    } catch (e) {
      setError(e instanceof Error ? e.message : "Checkout failed.");
      setBusyId(null);
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-8">
      <h1 className="text-2xl font-bold">210 Ground School</h1>
      <p className="mt-2 text-gray-600">
        Cessna 210 ground school — insurance-aligned initial / recurrent checkout. $600 per seat.
      </p>

      <div className="mt-6">
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
          Your email
        </label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="mt-1 w-full rounded border border-gray-300 p-2 focus:border-gray-500 focus:outline-none"
        />
      </div>

      {error && <p className="mt-3 text-sm text-red-600">{error}</p>}

      <ul className="mt-6 space-y-3">
        {cohorts.map((c) => (
          <li key={c.id} className="rounded border p-4">
            <div className="font-semibold">{c.name}</div>
            <div className="text-sm text-gray-500">
              Seats: {c.seat_cap} · Starts:{" "}
              {c.session1_at
                ? new Date(c.session1_at).toLocaleDateString()
                : "TBD"}
            </div>
            <button
              onClick={() => enroll(c.id)}
              disabled={busyId !== null}
              className="mt-3 rounded bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-700 disabled:opacity-50"
            >
              {busyId === c.id ? "Redirecting…" : "Enroll — $600"}
            </button>
          </li>
        ))}
      </ul>

      {status && <p className="mt-4 text-sm text-gray-500">{status}</p>}
    </div>
  );
}
